import { ApolloLink } from '@apollo/client';
import { print } from 'graphql';
import { sha256Hex } from './sha256';

export function createOperationHashLink() {
  return new ApolloLink((operation, forward) => {
    operation.extensions = {
      ...operation.extensions,
      persistedQuery: {
        version: 1,
        sha256Hash: sha256Hex(print(operation.query))
      }
    };
    operation.setContext(({ http = {} }) => ({
      http: {
        ...http,
        includeExtensions: true,
        includeQuery: true
      }
    }));
    return forward(operation);
  });
}
